import { VerificationStatus } from './VerificationStatus';

export const VerificationStatusOptions = [
  { value: VerificationStatus.ALL, label: 'All statuses' },
  { value: VerificationStatus.ACTIVE, label: 'Active' },
  { value: VerificationStatus.INACTIVE, label: 'Inactive' },
];
